// extracted by mini-css-extract-plugin
export default {"root":"styles_root__3hFTG","dragging-over":"styles_dragging-over__TY-i1","draggingOver":"styles_dragging-over__TY-i1","color":"styles_color__lWk6Q"};